<template>
  <div class="list-item">
    <div class="list-item__content">
      <p class="list-item__title">{{ title }}</p>
      <p v-if="description" class="list-item__description">{{ description }}</p>
    </div>
    <div v-if="info" class="list-item__info">{{ info }}</div>
  </div>
</template>

<script>
export default {
  name: 'ListItem',

  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.list-item {
  display: flex;
  align-items: flex-start;
  width: 100%;
  font-size: $font-size-small;

  &__content {
    flex: 1;
  }

  &__title,
  &__info {
    font-size: $font-size-small;
    color: $color-grey-dark-3;
    line-height: $line-height;
  }

  &__description {
    margin-top: 3px;
    font-size: $font-size-smaller;
    color: $color-grey-mid-2-5;
  }

  &__title {
    font-weight: bold;
  }

  &__info {
    margin-left: 20px;
  }
}
</style>
